export default __webpack_public_path__ + "static/media/ctEmailConfirm.5fb4ae10.png";